// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"110":"f63a1036bc16eb20b490","440":"56cca2755364d1b6f652","556":"f2fc2e5581141377c75b","581":"8d2158d6daabbb358864"}[chunkId] + ".js";
};